import CompteMock from "@/data/getCompte.json";
import {getBFF} from "@/function/getUrlProdOrPreprod";
import {CompteInfo} from "@/ts/interface/compte";

import {getDataMock} from "./_callApi";
import {callApi} from "./_callApi";

export async function fetchCompte(): Promise<CompteInfo | undefined> {
  if (getDataMock()) {
    const compteJson: string = JSON.stringify(CompteMock);
    const reponse: CompteInfo = JSON.parse(compteJson);
    return reponse;
  }
  let reponse = undefined;
  if (import.meta.env.VITE_APP_DEV === "true") {
    reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/massification/v1/me`,
      "GET",
      {
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
    );
  } else {
    reponse = await callApi(
      `${getBFF()}/massification/v1/me`,
      "GET",
      {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "include",
      null,
    );
  }
  const {
    email = "",
    lastname = "",
    firstname = "",
  }: {
    email: string | null;
    lastname: string | null;
    firstname: string | null;
  } = reponse;
  const compteInfo: CompteInfo = {
    nom: lastname ? lastname : "",
    prenom: firstname ? firstname : "",
    email: email ? email : "",
  };
  return compteInfo;
}
